// TumHaberler.tsx
import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalApi from "api/PortalApi";
import { useNavigate } from "react-router-dom";
import ListGridOnlyYear from "components/yenimahalle/ListGridOnlyYear";
import { AgendaItem } from "models/Response/Portal";

const MeclisGundemi: React.FC = () => {
  const [agendaList, setAgendaList] = useState<any[]>([]);
  const monthNames = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];
  const fetchData = async (year: string) => {
    const response = await PortalApi.getMeclisGundemi(parseInt(year));
    if (response && response.meclisList) {
      const mappedItems = response.meclisList.map((item: AgendaItem) => {
        const monthName = monthNames[item.month - 1];
        return {
          id: item.id,
          title: `${monthName} ${item.year}`,
          fileUrl: item.fileUrl,
        };
      });
      setAgendaList(mappedItems);
    }
  };

  const handleFilterChange = (year: string) => {
    fetchData(year);
  };

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear().toString();
    fetchData(currentYear);
  }, []);

  const handleCardClick = (item: AgendaItem) => {
    window.open(item.fileUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <Layout>
      <BasicHeader headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe" headingLine2="" />
      <ListGridOnlyYear
        items={agendaList}
        showDateFilter={true}
        onFilterChange={handleFilterChange}
        onItemClick={handleCardClick}
      />
    </Layout>
  );
};

export default MeclisGundemi;
